import {useState, useCallback, useEffect} from 'react';
// import Link from 'next/link';

import {api} from '@utils/api';
import {useApp} from '@context/AppProvider';
import styles from '@styles/dropAuction/dropAuctionLive.module.scss';
import TopAuctionItemCard from '@components/dropAuction/topAuction/topAuctionItemCard';

const TopAuction = ({limit = 8}) => {
	const {
		idb: {session},
	} = useApp();
	const [data, setData] = useState({
		check: false,
		topAuctionData: [],
	});

	const getTopAuction = useCallback(async () => {
		const topAuctionData = await api(
			{
				url: '/auction/get-completed-auctions',
				method: 'POST',
				data: {
					limit: limit,
				},
			},
			session,
		);
		console.log(topAuctionData);
		if (topAuctionData && topAuctionData.status) {
			setData({
				check: true,
				topAuctionData: topAuctionData.auctionProduct,
			});
		}
	}, [session]);

	useEffect(() => {
		if (!data.check && session) {
			getTopAuction();
		}
	}, [data.check, getTopAuction, session]);

	let html = '';

	if (data.topAuctionData) {
		html = (
			<div className={styles.goAgianSec}>
				<div className={styles.goAgianInner}>
					<div>
						<div
							className={`${styles.gridContainer} ${
								limit === 8 ? styles.limit8 : styles.limit6
							}`}
						>
							{data.topAuctionData &&
								data.topAuctionData.length > 0 &&
								data.topAuctionData.map((data, index) => (
									<TopAuctionItemCard data={data} key={index} />
								))}
						</div>
					</div>
				</div>
			</div>
		);
	}
	return html;
};

export default TopAuction;
